/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeviceNmsResponse } from '../../models/device-nms-response';
import { ZonedDateTime } from '../../models/zoned-date-time';

export interface GetDevices$Params {

/**
 * Page number
 */
  page: number;

/**
 * Page size
 */
  size: number;

/**
 * Filter to return records updated after specified time
 */
  updated_after?: ZonedDateTime;
}

export function getDevices(http: HttpClient, rootUrl: string, params: GetDevices$Params, context?: HttpContext): Observable<StrictHttpResponse<DeviceNmsResponse>> {
  const rb = new RequestBuilder(rootUrl, getDevices.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
    rb.query('updated_after', params.updated_after, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeviceNmsResponse>;
    })
  );
}

getDevices.PATH = '/api/nms/devices';
